import { render, staticRenderFns } from "./VisualizacionSeguidoresOyentesArtistas.vue?vue&type=template&id=54a0dc0e&scoped=true&"
import script from "./VisualizacionSeguidoresOyentesArtistas.vue?vue&type=script&lang=js&"
export * from "./VisualizacionSeguidoresOyentesArtistas.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacionSeguidoresOyentesArtistas.vue?vue&type=style&index=0&id=54a0dc0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a0dc0e",
  null
  
)

export default component.exports